import IngredientList from './IngredientList';
export default IngredientList;
